// removed by extract-text-webpack-plugin
module.exports = {"this":"GroupOrgList-OrganizationItem__this___3F3H2","container":"GroupOrgList-OrganizationItem__container___BYfxO","avatar":"GroupOrgList-OrganizationItem__avatar___3aqqQ","name":"GroupOrgList-OrganizationItem__name___1AzlB","badge":"GroupOrgList-OrganizationItem__badge___2cY1x"};


//////////////////
// WEBPACK FOOTER
// ./src/groups/components/styles/GroupOrgList-OrganizationItem.css
// module id = 2446
// module chunks = 0 1